import { render } from "./RMMobileCardView.vue?vue&type=template&id=5610306c&scoped=true"
import script from "./RMMobileCardView.vue?vue&type=script&lang=js"
export * from "./RMMobileCardView.vue?vue&type=script&lang=js"

import "./RMMobileCardView.vue?vue&type=style&index=0&id=5610306c&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5610306c"]])

export default __exports__